export function compareObjects(obj1, obj2) {
    const changedProps = {};

    const keys = new Set([...Object.keys(obj1), ...Object.keys(obj2)]);

    for (let key of keys) {
        const val1 = obj1[key];
        const val2 = obj2[key];

        if (!isEqual(val1, val2)) {
            if (Array.isArray(val1) && Array.isArray(val2)) {
                if (!arraysAreEqual(val1, val2)) {
                    changedProps[key] = val2;
                }
            } else if (
                typeof val1 === "object" &&
                typeof val2 === "object" &&
                val1 !== null &&
                val2 !== null
            ) {
                const nestedChanges = compareObjects(val1, val2);
                if (!isEmptyObject(nestedChanges)) {
                    changedProps[key] = nestedChanges;
                }
            } else {
                changedProps[key] = val2;
            }
        }
    }

    return changedProps;
}

function arraysAreEqual(arr1, arr2) {
    if (arr1.length !== arr2.length) {
        return false;
    }

    for (let i = 0; i < arr1.length; i++) {
        if (!isEqual(arr1[i], arr2[i])) {
            return false;
        }
    }

    return true;
}

function isEqual(val1, val2) {
    if (Array.isArray(val1) && Array.isArray(val2)) {
        return arraysAreEqual(val1, val2);
    } else if (
        typeof val1 === "object" &&
        typeof val2 === "object" &&
        val1 !== null &&
        val2 !== null
    ) {
        return isEmptyObject(compareObjects(val1, val2));
    } else {
        return val1 === val2;
    }
}

function isEmptyObject(obj) {
    return Object.keys(obj).length === 0;
}
